import React from 'react';
import I18n from 'app/i18n';
import {momentObj, fixed2} from 'app/utils';
import TimeToStartTimer from 'app/utils/TimeToStartTimer';
import daysClassComponent from 'app/utils/days_class_component';
import FrozenBalance from 'app/interfaces/FrozenBalanceInterface';
import {Link} from 'react-router-dom';
import {getLinkPath} from 'app/utils/link_helper';

interface Props {
    frozenBalances: FrozenBalance[];
    onExpire?: () => void;
    onClose?: () => void;
}

export default class FrozenBalanceTooltip extends React.PureComponent<Props> {
    formatTimer = (currentTime: number, timeToStart: number): React.ReactNode => {
        const daysComponent = daysClassComponent();
        const SEC60 = 60;
        const lastMinute = timeToStart - currentTime < SEC60;

        if (timeToStart === currentTime + 1 && this.props.onExpire) {
            requestAnimationFrame(() => this.props.onExpire!());
        }

        return (
            <span className="match-details__item-timer">
                {daysComponent({
                    diffDays: Number(momentObj(timeToStart).diff(momentObj(currentTime), 'days'))
                })}
                <div className="match-details__item-time-left">
                    {lastMinute ? '00:01' : momentObj(timeToStart - currentTime).format('HH:mm')}
                </div>
            </span>
        );
    };

    onClose = (): void => {
        this.props.onClose?.();
    };

    render(): React.ReactNode {
        const {frozenBalances} = this.props;
        const frozenBalance = frozenBalances?.[0];

        const showInfoLine = !frozenBalance || Number(frozenBalance.amount) === 0;

        return <>
            <span>{I18n.t('frozen_balance')}</span>
            {showInfoLine
                ? <p>{I18n.t('frozen_balance_description')}</p>
                : <>
                    <p>
                        {I18n.t('make_deposit_and_get_money', {string: fixed2(Number(frozenBalance.amount))})}
                        <br/>
                        {I18n.t('balance_expiry')}
                        <TimeToStartTimer time_to_start={frozenBalance.time} format={this.formatTimer} plainText/>
                    </p>
                </>}
            <Link to={getLinkPath('/faq/frozen-balance')} onClick={this.onClose}>
                {I18n.t('read_more_u')}
            </Link>
        </>;
    }
}
